<template>
  <div class="flex-column d-flex">
    <v-card rounded="0" width="100%" elevation="0" class="quiz-card">
      <Typography as="p" variant="h-5" class="quiz-question__title mb-0">
        {{ question.content }}{{ !isRequired ? " (optional)" : "" }}
      </Typography>
      <Typography as="p" variant="body-2" class="pt-5 quiz-question__helper mb-0">
        Enter your response in the text box below
      </Typography>
      <v-divider class="mt-5" />
      <v-textarea
        solo
        flat
        name="short-answer-input"
        label="Add your answer"
        v-model.lazy="shortAnswer"
        class="d-flex pa-3 short-answer-input"
      ></v-textarea>
      <v-divider />
      <!-- Div for buttons, if answered = false: submit, if answered = true: next question or complete -->
      <div class="d-flex justify-center mt-10">
        <v-btn
          :color="!inProgram ? 'brandPrimary' : 'brand'"
          :rounded="!inProgram"
          class="white--text"
          :loading="postingResponse"
          :disabled="isMissingRequiredValue(shortAnswer)"
          @click="answerQuestion"
          width="120"
          depressed
          v-if="answered == false"
        >
          {{ computedSubmitButton }}
        </v-btn>

        <v-btn
          :color="!inProgram ? 'brandPrimary' : 'brand'"
          :rounded="!inProgram"
          class="white--text"
          @click="goToNextQuestion"
          width="120"
          depressed
          v-if="!isLastQuestion && answered == true"
        >
          Next
        </v-btn>

        <v-btn
          color="brand"
          class="white--text"
          @click="completeQuiz"
          width="120"
          depressed
          v-else-if="isLastQuestion && answered == true && !isSurveyQuestion"
        >
          Complete
        </v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import quizQuestionResponseMixin from "@/components/learning/QuizQuestion/mixins/quizQuestionResponseMixin";

export default {
  name: "QuizQuestionShortAnswerV2",
  mixins: [quizQuestionResponseMixin],
  components: { Typography },
  data() {
    return {
      answered: false,
      shortAnswer: null,
    };
  },
  methods: {
    answerQuestion() {
      if (!this.answered) {
        this.submitAnswer();
      }
    },
    submitAnswer() {
      const normalizedShortAnswer = this.normalizeTextValue(this.shortAnswer);
      if (
        this.skipOptionalUnanswered(normalizedShortAnswer, {
          onSuccess: this.handleSuccess,
        })
      ) {
        return;
      }

      const quizQuestionResponse = this.buildBaseResponse({
        learningQuizAnswerId: null,
        value: normalizedShortAnswer,
        correctness: null,
      });

      this.postResponseAndAdvance([quizQuestionResponse], {
        onSuccess: this.handleSuccess,
        onError: this.handleError,
      });
    },
    handleSuccess() {
      this.answered = true;
      this.goToNextQuestion();
    },
    handleError() {
      this.answered = false;
    },
    goToNextQuestion() {
      if (!this.isLastQuestion) {
        this.answered = false;
        this.shortAnswer = null;
        this.$emit("next-question", true);
      } else {
        this.completeQuiz();
      }
    },
    completeQuiz() {
      this.$emit("complete-quiz", true);
    },
  },
};
</script>

<style scoped>
/* Figma: question = Headline/h5, helper = Body/Body 2, input label = Body/Body 1 */
.quiz-question__title {
  color: rgba(0, 0, 0, 0.87);
  word-break: normal;
}

.quiz-question__helper {
  color: rgba(0, 0, 0, 0.6);
}

.quiz-card >>> .v-label {
  font-family: "Avenir Book", Helvetica, Arial, sans-serif !important;
  font-size: 16px !important;
  line-height: 1.5em !important;
  color: rgba(0, 0, 0, 0.87) !important;
}

.short-answer-input {
  max-width: 90%;
  margin: 0 auto;
}
@media only screen and (max-width: 700px) {
  .short-answer-input {
    max-width: 100%;
    padding: 0 !important;
  }
}
</style>
